import { render, staticRenderFns } from "./RecogPositionEdit.vue?vue&type=template&id=0f5c53fa&scoped=true&"
import script from "./RecogPositionEdit.vue?vue&type=script&lang=ts&"
export * from "./RecogPositionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./RecogPositionEdit.vue?vue&type=style&index=0&id=0f5c53fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5c53fa",
  null
  
)

export default component.exports